import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../../Components/Form";
import StickyToolbar from "../../../../../Components/StickyToolbar";
import { ListarClientesPorNome } from "../../../../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import { ListarUsuariosController } from "../../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { IFiltroGestaoContaChatFechado } from "../../../../../Interfaces/HelpDesk/GestaoAtendimentos/GestaoAtendimentosInterface";
import StorageManagerCapys from "../../../../../Tools/Storage";

type AtendimentosFechadosFilterType = Omit<
    IFiltroGestaoContaChatFechado,
    "NR_PAGINA"
>;

interface IAtendimentosFechadosFilterProps {
    handleSubmit: (filter: AtendimentosFechadosFilterType) => void;
    defaultFilter?: AtendimentosFechadosFilterType;
    storageManager: StorageManagerCapys<AtendimentosFechadosFilterType>;
}

const filtroInicial: AtendimentosFechadosFilterType = {
    NR_TELEFONE: "",
    DT_FIM_CHAT_INICIAL: "",
    DT_FIM_CHAT_FINAL: "",
    DT_INICIO_CHAT_INICIAL: "",
    DT_INICIO_CHAT_FINAL: "",
    ID_CONTA: 0,
    ID_CONTATO: 0,
    ID_USUARIO_ATENDENTE: 0,
    ID_CASO: 0,
}

export default function AtendimentosFechadosFilter(
    props: IAtendimentosFechadosFilterProps
) {
    const hadleFilterFormSubmit = props.handleSubmit;
    const FormMethods = useForm({
        defaultValues: props.defaultFilter,
    });
    const { reset } = FormMethods;
    
    function limparFiltros() {
        reset(filtroInicial);
        props.storageManager.remove();
    }
    
    return ( 
        <StickyToolbar active={Boolean(props.defaultFilter)}>
            <FormProvider {...FormMethods}>
                <UnForm
                    usingContext
                    handleSubmit={hadleFilterFormSubmit}
                    className="row no-gutters"
                >
                    <div className="form-group row">
                        <label className="col-12">Data de Início</label>
                        <div className="col-6">
                            <UnForm.Input
                                type="date"
                                defaultValue={props.defaultFilter?.DT_INICIO_CHAT_INICIAL}
                                name="DT_INICIO_CHAT_INICIAL"
                            />
                        </div>
                        <div className="col-6">
                            <UnForm.Input
                                type="date"
                                defaultValue={props.defaultFilter?.DT_INICIO_CHAT_FINAL}
                                name="DT_INICIO_CHAT_FINAL"
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-12">Data Final</label>
                        <div className="col-6">
                            <UnForm.Input
                                type="date"
                                defaultValue={props.defaultFilter?.DT_FIM_CHAT_INICIAL}
                                name="DT_FIM_CHAT_INICIAL"
                            />
                        </div>
                        <div className="col-6">
                            <UnForm.Input
                                type="date"
                                defaultValue={props.defaultFilter?.DT_FIM_CHAT_FINAL}
                                name="DT_FIM_CHAT_FINAL"
                            />
                        </div>
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="tel"
                            name="NR_TELEFONE"
                            label="Telefone"
                            defaultValue={props.defaultFilter?.NR_TELEFONE}
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="number"
                            name="ID_CASO"
                            label="Número de protocolo"
                            defaultValue={props.defaultFilter?.ID_CASO}
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <label>Cliente</label>
                        <UnForm.SearchSelect
                            controller={ListarClientesPorNome}
                            getDS={(u) => u.DS_CONTA}
                            name="ID_CONTA"
                            getKeyValue={(u) => u.ID_CONTA}
                            defaultValue={props.defaultFilter?.ID_CONTA}
                            allowClear
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.LazySelect
                            label="Atendente"
                            controller={ListarUsuariosController}
                            getDS={(u) => u.DS_NOME}
                            getKeyValue={(u) => u.ID_USUARIO}
                            defaultValue={props.defaultFilter?.ID_USUARIO_ATENDENTE}
                            name="ID_USUARIO_ATENDENTE"
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>
                    <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                        <button
                            type="submit"
                            className="btn btn-block btn-outline-dark mt-2"
                        >
                            <FontAwesomeIcon icon={faFilter} className="mr-2" />
                            Filtrar
                        </button>
                    </div>
                    <div className="col-12 d-flex align-items-end justify-content-start">
                        <button
                            type="button"
                            onClick={limparFiltros}
                            className="btn btn-block btn-outline-danger mt-2"
                        >
                            <FontAwesomeIcon icon={faTimes} className="mr-2" />
                            Limpar Filtros
                        </button>
                    </div>
                </UnForm>
            </FormProvider>
        </StickyToolbar>
    );
}
